import {Component, OnInit, Input, OnDestroy} from '@angular/core';

import * as moment from 'moment';
import {map, filter, take} from 'rxjs/operators';
import {TimeCard} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card';
import {MatDialog} from '@angular/material/dialog';
import {DeviceDetectorService} from 'ngx-device-detector';
import {TimeCardService} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {TimeCardsQuery} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-cards.query';
import {takeUntilDestroyed} from 'projects/core/src/public-api';
import {interval, Subject} from 'rxjs';
import {
  PunchWidgetDialogComponent
} from 'projects/app-misc/src/app/modules/punch-time-widget/view/punch-widget-dialog/punch-widget-dialog.component';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {WsUpdateResponce} from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import {User} from 'projects/core/src/lib/login/data/user';
import {takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';


@Component({
  selector: 'app-widget-bar',
  templateUrl: './widget-bar.component.html',
  styleUrls: ['./widget-bar.component.scss']
})
@RxJSUnsubscribe
export class WidgetBarComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  isMobile: boolean;

  punchedIn$ = this.timeCardsQuery.punchedIn$
  trackWorkTime$ = this.timeCardsQuery.trackWorkTime
  currentUser$ = this.appStateQuery.currentUser$

  currentUser: User;

  inTime$ = this.timeCardsQuery.firstTimeCard
    .pipe(
      map(firstCard => firstCard ? moment(firstCard.startTime).format('hh:mm A') : '')
    )

  outTime$ = this.timeCardsQuery.lastTimeCard
    .pipe(
      map(lastCard => lastCard && lastCard.finishTime ? moment(lastCard.finishTime).format('hh:mm A') : '')
    )

  lastTimeCard: TimeCard;

  breakType: string;

  totalTime: string;

  userId: number;

  constructor(
    private dialog: MatDialog,
    private deviceService: DeviceDetectorService,
    private timeCardService: TimeCardService,
    protected appStateQuery: AppStateQuery,
    protected timeCardsQuery: TimeCardsQuery,
    protected wsService: WsService
  ) {
  }


  ngOnInit() {
    this.currentUser$.subscribe(user => {
      this.userId = user.id;
      this.currentUser = user;

      this.trackWorkTime$
        .pipe(
          takeUntil(this.getUnsubFromAllSubs()),
          filter(trackWorkTime => trackWorkTime),
          take(1)
        )
        .subscribe(status => {
          if (this.currentUser.allowMobileClockIn) {
            this.onWorkTimeTrackNeeded()
          }
        })

      if (user.trackWorkTime) {
        this.getTodayTotalTime();
        this.getWeekTotalTime();

        interval(30000)
          .pipe(
            takeUntil(this.getUnsubFromAllSubs())
          )
          .subscribe(emit => {
            this.getTodayTotalTime();
            this.getWeekTotalTime();
          })

        this.timeCardsQuery.todayTotalTime$.subscribe(time => {
          const totalHours = Math.trunc(time / 60)
          const totalMinutes = Math.trunc(time - totalHours * 60)
          this.totalTime = totalHours + 'h ' + totalMinutes + 'm'
        })
        this.timeCardsQuery.lastTimeCard.subscribe(card => this.lastTimeCard = card)

      }
    })

    this.timeCardsQuery.breakType$.subscribe(type => {
      this.breakType = type;
    })
  }

  getTodayTotalTime() {
    const today = moment().format('YYYY-MM-DD')
    this.timeCardService.getTodayTotalTime(this.userId, today, today).subscribe(time => {
    })
  }

  getWeekTotalTime() {
    const startWeek = moment().startOf('week').format('YYYY-MM-DD');
    const endWeek = moment().endOf('week').format('YYYY-MM-DD');

    this.timeCardService.getWeekTotalTime(this.userId, startWeek, endWeek).subscribe(time => {
    })
  }

  onWorkTimeTrackNeeded(): void {
    this.timeCardService.getTodayCards().subscribe(todayCards => {
      if (todayCards.length === 0 && !this.timeCardService.openedAfterRefresh) {
        this.openPunchWidget();
      }
    });
  }


  openPunchWidget() {
    this.timeCardService.openedAfterRefresh = true;

    const dialogRef = this.dialog.open(PunchWidgetDialogComponent, {
      disableClose: false,
      panelClass: 'punch-widget-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });

  }

  ngOnDestroy() {
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
